<ng-container *ngIf="text?.length <= limit" >
  {{text}}
</ng-container>

<ng-container *ngIf="text?.length > limit" >
  {{truncated ? (text | truncate : limit) : text }}

  <button *ngIf="showButton" class="btn btn-link primary-bg-color primary-text-color no-padding font-primary toggle-link" (click)="toggleTruncated()">
    {{truncated ? readMoreText : readLessText}}
  </button>
</ng-container>
